var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4288 10.2128C19.6062 11.1134 19.6062 12.8866 18.4288 13.7872L18.8844 14.3829L18.4288 13.7872L18.2342 13.936C17.441 14.5427 16.9225 15.4407 16.7937 16.431L16.7621 16.6739C16.571 18.1439 15.0353 19.0305 13.6666 18.4611L13.4405 18.367C12.5185 17.9834 11.4815 17.9834 10.5595 18.367L10.8476 19.0595L10.5595 18.367L10.3334 18.4611C8.96473 19.0305 7.42904 18.1439 7.23786 16.6739L7.20627 16.431C7.07747 15.4407 6.559 14.5427 5.76577 13.936L5.57122 13.7872L5.11558 14.3829L5.57122 13.7872C4.39377 12.8866 4.39377 11.1134 5.57122 10.2128L5.76578 10.064C6.559 9.45732 7.07747 8.5593 7.20627 7.569L7.23786 7.3261C7.42904 5.85613 8.96473 4.96949 10.3334 5.53891L10.5595 5.633C11.4815 6.01661 12.5185 6.01661 13.4405 5.633L13.6666 5.53892C15.0353 4.96949 16.571 5.85613 16.7621 7.3261L16.7937 7.569C16.9225 8.5593 17.441 9.45732 18.2342 10.064L18.4288 10.2128Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8398 14.3398C13.2206 14.3398 14.3398 13.2206 14.3398 11.8398C14.3398 10.4591 13.2206 9.33984 11.8398 9.33984C10.4591 9.33984 9.33984 10.4591 9.33984 11.8398C9.33984 13.2206 10.4591 14.3398 11.8398 14.3398Z",
    fill: "#6921C4",
    stroke: "#6921C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settingsActive.d3a3491e.svg";
export { ForwardRef as ReactComponent };